<ng-content></ng-content>


// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/shared/simple-mde/simple-mde.component.ts.SimpleMDEComponent.html